import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { Constants } from 'src/app/shared/constants';

@Injectable({
  providedIn: 'root'
})
export class TherapistRoleGuard {
  constructor(private router: Router, private authenticationService: AuthenticationService) {}

  canActivate(): boolean | UrlTree {
    if (!this.authenticationService.isAuthenticated()) {
      return true; 
    }
    const roleName = this.authenticationService.getCurrentUserToken()?.roleName;
    if (roleName === Constants.userType.Therapist) {
      return true;
    }
    return this.router.parseUrl('/admin/dashboard');
  }
}
